import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-settings-nav',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-settings-nav.component.html',
  styleUrl: './app-settings-nav.component.css'
})
export class AppSettingsNavComponent {
  @Input() activePanel: string = 'personal';
  @Output() panelChange = new EventEmitter<string>();

    setActivePanel(panel: string): void {
    this.panelChange.emit(panel);
  }
}
